import { render, staticRenderFns } from "./ContractManagementListItem.vue?vue&type=template&id=2b340a60"
import script from "./ContractManagementListItem.vue?vue&type=script&lang=js"
export * from "./ContractManagementListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports